import { render } from "./Sidebar.vue?vue&type=template&id=9142c7a4&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "@/assets/scss/_sidebar.scss?vue&type=style&index=0&id=9142c7a4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9142c7a4"]])

export default __exports__